import { AccesOperation } from './acces-operation.entity';
import { AccesDemandeIntervention } from './acces-demande-intervention.entity';
import { Notification } from './notification.entity';
import { WorkOrder } from './work-order.entity';

export class AccesOperationBinderEntity {
	
	accesId!: number;
	creationNouvellesOperations: AccesOperation[] = [];
	liaisonAvecOperationsExistantes: AccesOperation[] = [];
	liaisonAvecDemandeInterventions: AccesDemandeIntervention[] = [];
	liaisonAvecWorkOrders: WorkOrder[] = [];
	liaisonAvecNotifications: Notification[] = [];
	aucunActeAssociable: boolean = false;
}